export enum Deductible {
  deductible500 = 500,
  deductible1000 = 1000,
}
